import { createSelector } from 'reselect';

import type { RootState } from 'typesafe-actions';
import type { RouterState } from './reducer';

export const getRouter = (state: RootState) => state.router;

export const getLocation = createSelector(
  getRouter,
  (state: RouterState) => state.location?.location || {},
);

export const getHost = createSelector(getRouter, (state: RouterState) => state.host);

export const getLocationAction = createSelector(
  getRouter,
  (state: RouterState) => state.location.action,
);

export const getProtocol = createSelector(
  getRouter,
  (state: RouterState) => state.location.protocol,
);

export const getLocationPending = createSelector(
  getRouter,
  (state: RouterState) => state.location.isPending,
);
